import { CLASS_NAME_PREFIX } from "../__config__/constants";

export const InputClassName = `${CLASS_NAME_PREFIX}-input`;
export const InputLabelClassName = `${InputClassName}__label`;
export const InputSectionClassName = `${InputClassName}__input-section`;
export const InputSectionInputClassName = `${InputSectionClassName}-input`;
export const InputIconClassName = `${InputSectionClassName}-icon`;
export const InputStartIconClassName = `${InputIconClassName}-start`;
export const InputEndIconClassName = `${InputIconClassName}-end`;
export const InputStartIconDisabledClassName = `${InputStartIconClassName}-disabled`;
export const InputEndIconDisabledClassName = `${InputEndIconClassName}-disabled`;
export const InputPostfixClassName = `${InputClassName}-postfix`;
